import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const ReportsIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M0.75 12.5V3.5C0.75 2.5335 1.5335 1.75 2.5 1.75H4.14258C4.41872 1.75 4.64258 1.97386 4.64258 2.25C4.64258 2.52614 4.41872 2.75 4.14258 2.75H2.5C2.08579 2.75 1.75 3.08579 1.75 3.5V12.5C1.75 12.9142 2.08579 13.25 2.5 13.25H13.5C13.9142 13.25 14.25 12.9142 14.25 12.5V10C14.25 9.72386 14.4739 9.5 14.75 9.5C15.0261 9.5 15.25 9.72386 15.25 10V12.5C15.25 13.4665 14.4665 14.25 13.5 14.25H2.5C1.5335 14.25 0.75 13.4665 0.75 12.5Z"
      fill="currentColor"
    />
    <path
      d="M14.2499 5.20929V2.72867H11.7499C11.4738 2.72867 11.2499 2.50655 11.2499 2.23254C11.2499 1.95854 11.4738 1.73642 11.7499 1.73642H14.7499C15.026 1.73642 15.2499 1.95854 15.2499 2.23254V5.20929C15.2499 5.48329 15.026 5.70541 14.7499 5.70541C14.4738 5.70541 14.2499 5.48329 14.2499 5.20929Z"
      fill="currentColor"
    />
    <path
      d="M14.1963 2.08016C14.3915 1.88649 14.7081 1.88665 14.9033 2.08016C15.0986 2.27391 15.0986 2.58796 14.9033 2.78171L10.8535 6.80012C10.6752 6.97703 10.3924 6.99441 10.1934 6.84082L8.29103 5.37279L5.60353 8.04043C5.40827 8.23418 5.09176 8.23418 4.8965 8.04043C4.70137 7.84667 4.70128 7.53258 4.8965 7.33888L7.8965 4.36213L7.96779 4.30303C8.14406 4.18343 8.38257 4.18727 8.55666 4.32144L10.458 5.78849L14.1963 2.08016Z"
      fill="currentColor"
    />
  </svg>
);
